import { PapiDaUserProfileInitStats } from '@wix/da-types-papi';

export enum StatsTimePeriod {
  Week = 'P7D',
  Month = 'P28D',
  Year = 'P365D',
}

export enum MySubmissionsSortBy {
  PublishDate = 'publish_date',
  PageViews = 'page_views',
  Faves = 'faves',
  Comments = 'comments',
}

export type MySubmissionItem = NonNullable<
  NonNullable<
    NonNullable<PapiDaUserProfileInitStats['sectionData']>['myContent']
  >['timePeriods']['P7D']
>[0];

export type GeneralStats = NonNullable<
  NonNullable<
    NonNullable<PapiDaUserProfileInitStats['sectionData']>['general']
  >['timePeriods']['P7D']
>;

export type DeviceStats = NonNullable<
  NonNullable<
    NonNullable<PapiDaUserProfileInitStats['sectionData']>['trafficByDevice']
  >['timePeriods']['P7D']
>;

export type CountryStats = NonNullable<
  NonNullable<
    NonNullable<PapiDaUserProfileInitStats['sectionData']>['trafficByCountry']
  >['timePeriods']['P7D']
>;

type StatsSection = {
  timePeriod: StatsTimePeriod;
  mySubmissionsSortBy: MySubmissionsSortBy;
  mySubmissionsIsLoading: boolean;
  stats: Without<
    NonNullable<PapiDaUserProfileInitStats['sectionData']>,
    'traffic' | 'general'
  > & {
    traffic?: NonNullable<PapiDaUserProfileInitStats['sectionData']>['traffic'];
    general?: NonNullable<PapiDaUserProfileInitStats['sectionData']>['general'];
    trafficByDevice?: NonNullable<
      PapiDaUserProfileInitStats['sectionData']
    >['trafficByDevice'];
    trafficByCountry?: NonNullable<
      PapiDaUserProfileInitStats['sectionData']
    >['trafficByCountry'];
    hasCalculatedStats?: boolean;
  };
};

export default StatsSection;
